



























































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import RollForwardAccountDateRequest from '@/models/Accounts/DepositAccounts/Tools/RollForwardAccountDateRequest';

@Component({ name: 'RollForwardDatesTool' })
export default class extends SaascadaVueDialog {

    dialog: boolean = false;
    request = new RollForwardAccountDateRequest();
    startDateAsString: string = new Date().toISOString().split('T')[0];
    endDateAsString: string = '';
    todaysDateAsString: string = new Date().toISOString().split('T')[0];

    @Watch('dialog')
    onDialogChanged(val: boolean) {
        if (val) {
            this.todaysDateAsString = new Date().toISOString().split('T')[0];
            // Set default value for start date depending on what is available
            if (this.account.currentTestDateUtc) {
                this.startDateAsString = new Date(this.account.currentTestDateUtc).toISOString().split('T')[0];
            }
            else {
                this.startDateAsString = this.todaysDateAsString;
            }
            // Set the end date as the start date by default (end date can't be before start date)
            this.endDateAsString = this.startDateAsString;
        }
    }

    get account() {
        return DepositAccountModule.depositAccount;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            this.request.startDateUtc = this.startDateAsString;
            this.request.endDateUtc = this.endDateAsString;
            this.request.accountId = this.account.id;

            await DepositAccountModule.rollForwardAccountDate(this.request);
        }
    }

    close() {
        this.dialog = false;
    }

};
